import React from 'react'
import Back from '../common/Back/Back'
import AboutCurd from './AboutCurd'

export default function About() {
    return (
        <div>
            <Back  title={"About US"}/>
            <AboutCurd/>
        </div>
    )
}
